<template>
	<form-field-wrap
		:field-props="fieldProps"
		:is-error="isError"
		:field-value="fieldValue"
		:is-switch="isSwitch"
		:input-focus="inputFocus"
		:with-label="fieldProps.withLabel"
	>
		<template>
			<input class="form-field__input"
			       :class="[inputClass, fieldProps.CLASS ? 'form-field__input_'+fieldProps.CLASS : 'form-field__input_'+fieldProps.CODE, (fieldValue || inputFocus) ? 'is-fill' : '']"
			       v-if="maskTemplate"
			       type="text"
			       autocomplete="off"
			       v-mask="maskTemplate"
			       v-validate="rules"
			       :placeholder="fieldProps.PLACEHOLDER"
			       :data-vv-as="fieldProps.TITLE"
			       :name="fieldProps.CODE"
			       :value="fieldValue"
			       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			       :disabled="disable"
			       @input="changeValue"
			       @focus="labelSwitch('focus')"
			       @blur="labelSwitch">
			<input class="form-field__input"
			       :class="[inputClass, fieldProps.CLASS ? 'form-field__input_'+fieldProps.CLASS : 'form-field__input_'+fieldProps.CODE, (fieldValue || inputFocus) ? 'is-fill' : '']"
			       v-else
			       type="text"
			       autocomplete="off"
			       v-validate="rules"
			       :placeholder="fieldProps.PLACEHOLDER"
			       :data-vv-as="fieldProps.TITLE"
			       :name="fieldProps.CODE"
			       :value="fieldValue"
			       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			       :disabled="disable"
			       @input="changeValue"
			       @focus="labelSwitch('focus')"
			       @blur="labelSwitch">
		</template>
	</form-field-wrap>
</template>

<script>
// необходим для дочерних компонентов (rating)
import {IconManager} from "citrus.config";

export default {
	name: "FormFieldText",
	props: {
		fieldProps: {
			type: [Object, Array],
			default: function () {
				return {}
			}
		},
		value: {
			type: [Array, String, Number, Boolean],
			default: function () {
				return []
			}
		},
		isSwitch: {
			type: Boolean,
			default: false
		},
		disable: {
			type: Boolean,
			default: false
		},
		inputClass: {
			type: String,
			default: ''
		}
	},
	data: function () {
		return {
			inputFocus: false,
			inputValue: "",
			error: false,
		}
	},
	created: function () {
		this.inputValue = Array.isArray(this.value) ? this.value[0] : this.value;
	},
	watch: {
		value(newValue, oldValue) {
			this.inputValue = newValue;
		},
		error() {
			this.$emit('is-error', {
				error: this.error
			});
		}
	},
	computed: {
		maskTemplate() {
			return (this.fieldProps.hasOwnProperty('MASK') ? this.fieldProps.MASK : false);
		},
		rules() {
			let arRules = [];

			if (this.fieldProps.REQUIRED == "Y") {
				arRules.push('required');
			}
			if (this.fieldProps.RULES) {
				arRules = arRules.concat(this.fieldProps.RULES);
			}

			let stRules = arRules.join('|');
			return stRules;
		},
		fieldValue() {
			return this.inputValue;
		},
		isError() {
			this.error = this.errors.first(this.fieldProps.CODE);
			return this.error;
		},
	},
	methods: {
		changeValue: function ($event) {
			this.inputValue = $event.target.value;
			this.$emit('input', $event.target.value);
		},
		labelSwitch(active) {
			if (active == 'focus') {
				this.inputFocus = true;
			} else {
				this.inputFocus = false;
			}

			this.$emit('input-focus', this.inputFocus);
		},
		async checkValid() {
			let validate = this.$validator.validate().then(result => {
				if (result) {
					return true;
				} else {
					return false;
				}
			}).catch(() => {
				return false;
			});

			let result = await validate;
			return result;
		},
		resetValid: async function () {
			this.$validator.reset();
		},
		IconManager,
	},
}
</script>
